/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/aria-role */
import {
  Modal, Fade, Typography, Backdrop,
} from '@material-ui/core';
import Cookies from 'js-cookie';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BanTemporarily from '@assets/images/ban_and_lock/ban-tempo.png';

import { userLogout } from '@shared/services/shareAuthenticationApi';
import unsetSegmentIdentity from '@shared/utils/UnsetSegmentIdentity';
import './UserAccountLock.css';

const useStyles = makeStyles((theme) => ({
  lockModal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '999',
  },
  lockPaper: {
    position: 'relative',
    textAlign: 'center',
    color: '#74777A',
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.paper,
    padding: '60px 15px 30px',
    boxSizing: 'border-box',
    margin: '0 10px',
    width: '100%',
    maxWidth: '580px',
    borderRadius: '15px',
    [theme.breakpoints.down('sm')]: {
      padding: '60px 15px 40px',
    },
  },
}));

function UserAccountLock({ banModalStatus }) {
  const [modalStatus, setModalStatus] = useState(banModalStatus);
  const modalClasses = useStyles();

  const closeLockModal = () => {
    setModalStatus(false);
    if (Cookies.get('token')) {
      const userToken = Cookies.get('token');
      userLogout(userToken)
        .then(((response) => {
          if (response.status === 200 && response.data.code === '200') {
            // Unset Segment Identity
            unsetSegmentIdentity();
            // remove token we set
            Cookies.remove('token');
            Cookies.remove('uid');
            // segment tracking
            if (process.env.REACT_APP_ON_SEGMENT === 'true') {
              const event = 'Signed Out';
              window.analytics.track(event, {});
            }
            window.location.reload();
          }
        }))
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <Modal
      className={modalClasses.lockModal}
      open={modalStatus}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={modalStatus}>
        <div className={modalClasses.lockPaper}>
          <div role='close-btn'>
            <CloseIcon className='close-lock-modal-icon' onClick={closeLockModal} />
          </div>
          <div className='lock-message-holder'>
            <img src={BanTemporarily} alt='temporary-ban-account-icon' />
            <Typography>
              Your account has been locked for
              violating the community guidelines. For questions, email
              <a href='mailto:support@kumu.ph'>support@kumu.ph</a>
            </Typography>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}

export default UserAccountLock;
